import React from 'react';
import type { BombiixIconProps } from './types';

/**
 * Bombiix Location Pin icon — outlined pin marker with inner circle.
 * Uses `currentColor` so the parent `.bombiix-icon-container` modifier drives the tint.
 */
const LocationPinIcon: React.FC<BombiixIconProps> = ({ size = 20, ...rest }) => (
  <svg width={size} height={size} viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" {...rest}>
    <path
      d="M2.47182 8.59073C2.26437 7.97977 2.14282 7.33013 2.14282 6.65263C2.14282 3.1403 5.25368 0.319223 8.99864 0.548722C12.1736 0.74321 14.7548 3.18173 14.9834 6.20152C15.0431 6.98973 14.9382 7.74697 14.717 8.45362C13.685 11.7507 8.57256 16.6071 8.57256 16.6071C8.57256 16.6071 3.76047 12.3848 2.47182 8.59073Z"
      stroke="currentColor"
      strokeWidth="0.803571"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M11.7857 6.96439C11.7857 8.73963 10.3466 10.1786 8.57146 10.1786C6.79628 10.1786 5.35718 8.73963 5.35718 6.96439C5.35718 5.18915 6.79628 3.75 8.57146 3.75C10.3466 3.75 11.7857 5.18915 11.7857 6.96439Z"
      stroke="currentColor"
      strokeWidth="0.803571"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default LocationPinIcon;
